import { getData } from "actions";
import axios from "axios";
import { API_URL_rating, API_URL_ticket } from "constants/api";
import React, { useCallback, useEffect, useState } from "react";
import { FaMinusCircle } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { ratingReducers } from "redux/ratingSlice";
import { generateNumberSequence } from "utils/generateNumberSequence";

const RatingButtons = ({ useCancel = true, item, callback }) => {
  const [selectedRating, setSelectedRating] = useState(null);
  const dispatch = useDispatch();
  const [ratingScale, setRatingScale] = useState([]);
  const { getRatingResult } = useSelector((state) => state.rating);

  const fetchRating = useCallback(
    async (params) => {
      getData(
        API_URL_rating,
        params,
        { dispatch, redux: ratingReducers },
        "GET_RATING"
      );
    },
    [dispatch]
  );

  const handleRatingClick = (rating) => {
    if (selectedRating === rating) {
      setSelectedRating(null); // Jika tombol rating yang sama di-klik lagi, batalkan pemilihan
    } else {
      setSelectedRating(rating); // Pilih rating yang di-klik
    }
    if (rating === null) {
      rating = 0;
    }
    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "PUT",
      data: { rating: rating },
      url: API_URL_ticket + item.id + "/",
    })
      .then((response) => {
        if (rating !== null) {
          callback();
          toast.success("Terima kasih atas penilaian layanan kami", {
            position: "top-center",
            autoClose: true,
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        toast.warning(error.response.data.message, {
          position: "top-center",
          autoClose: true,
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        callback();
      });
  };

  useEffect(() => {
    if (item) {
      setSelectedRating(item.rating);
    }
  }, [item]);

  useEffect(() => {
    fetchRating("1/");
  }, []);

  useEffect(() => {
    if (getRatingResult) {
      setRatingScale(generateNumberSequence(getRatingResult.rating_scale));
    }
  }, [getRatingResult]);

  return (
    <div className="flex items-center">
      {useCancel === true && (
        <button title="cancel" onClick={() => handleRatingClick(null)}>
          <FaMinusCircle className="text-gray-500 hover:text-red-500" />
        </button>
      )}
      {ratingScale && useCancel === true
        ? ratingScale.map((rating, index) => (
            <button
              key={rating}
              title={index + 1}
              className="text-xl"
              onClick={() => handleRatingClick(rating)}
              style={{ color: selectedRating >= rating ? "orange" : "black" }}
            >
              ★
            </button>
          ))
        : ratingScale.map((rating, index) => (
            <button
              key={rating}
              title={index + 1}
              className="text-xl cursor-default"
              style={{ color: selectedRating >= rating ? "orange" : "black" }}
            >
              ★
            </button>
          ))}
    </div>
  );
};

export default RatingButtons;
